// #1932 直近に見ていた画面を覚えておく。不具合の問い合わせに自動で添えるため。
//
// **「直前の画面」だけでは役に立たない。** 不具合に遭った人は
// 「注文履歴 → プロフィール → お問い合わせ」と辿るので、直前は必ず
// プロフィールになる。何件か遡って初めて「どこで起きたか」が見える。
//
// 保存先は sessionStorage (タブを閉じたら消える)。**アカウントとは紐づけない。**

const KEY = 'yokoso.recentRoutes.v1'
const MAX = 8

/** 問い合わせ画面そのものは記録しない (毎回そこで埋まってしまう) */
const IGNORED = ['/contact']

export function recordRoute(path: string): void {
  if (!path || IGNORED.includes(path)) return
  try {
    const list = readRoutes()
    // 同じ画面の連続は 1 つにまとめる (リダイレクトや再描画で埋まらないように)
    if (list[list.length - 1] === path) return
    list.push(path)
    sessionStorage.setItem(KEY, JSON.stringify(list.slice(-MAX)))
  } catch {
    // sessionStorage が使えない環境では諦める (問い合わせ自体は送れる)
  }
}

export function readRoutes(): string[] {
  try {
    const raw = sessionStorage.getItem(KEY)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? parsed.filter((v): v is string => typeof v === 'string') : []
  } catch {
    return []
  }
}
